import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Routes, Route, Link } from "react-router-dom";
import PrivacyPolicy from './screens/PrivacyPolicy';
import About from './screens/About';
import Routing from './router';


function App() {
  return (
    <div>
      {/* <nav>
        <Link to="/">About</Link> |
        <Link to="/privacy-policy">Privacy Policy</Link> |
      </nav>

      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes> */}
        <Routing />
    </div>

  );
}

export default App;
